import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]
  static outlets = ["unread-badge"]

  downloadClick(event) {
    const tr = event.currentTarget.closest("tr")

    if (tr && tr.classList.contains("link_not_bold")) {
      tr.classList.remove("link_not_bold")

      this.unreadBadgeOutlets.forEach(outlet => outlet.decreaseCounter())
    }
  }
}
